import { ifError } from "assert";

function StaffMembers(staffMemberContainers) {
	staffMemberContainers = [].slice.call(staffMemberContainers);

	this.staffMembers = staffMemberContainers.map(container => {
		return {
			container: container,
			button: container.querySelector('.staff-member-button'),
			descriptionContainer: container.querySelector('.staff-member-description'),
			buttonCloseDescription : container.querySelector('.staff-member-description-button-close')
		};
	});

	this.toggleDescription = this.toggleDescription.bind(this);

	this.staffMembers.forEach(staffMember => {
		if (staffMember.button) {
			staffMember.button.addEventListener('click', function() {
				this.toggleDescription(staffMember);
			}.bind(this));

			if (staffMember.buttonCloseDescription) {
				staffMember.buttonCloseDescription.addEventListener('click', function() {
					this.closeDescription(staffMember);
				}.bind(this));
			}
		}
	});
}

StaffMembers.prototype.toggleDescription = function(staffMember) {
	if (!staffMember.descriptionContainer.classList.contains('is-open')) {
		this.closeAllOpenDescriptions();
	}

	staffMember.button.classList.toggle('is-active');
	staffMember.container.classList.toggle('is-active');
	staffMember.descriptionContainer.classList.toggle('is-open');
};

StaffMembers.prototype.closeDescription = function(staffMember) {
	staffMember.button.classList.remove('is-active');
	staffMember.container.classList.remove('is-active');
	staffMember.descriptionContainer.classList.remove('is-open');
};

StaffMembers.prototype.closeAllOpenDescriptions = function() {
	this.staffMembers.forEach(staffMember => {
		staffMember.button.classList.remove('is-active');
		staffMember.container.classList.remove('is-active');
		staffMember.descriptionContainer.classList.remove('is-open');
	});
};

export default StaffMembers;